module.exports = __webpack_public_path__ + "img/workNewsCover3.dce7f1b3.png";